export const MY_OWL_FORMATS = {
  parseInput: 'DD/MM/YYYY',
  fullPickerInput: 'DD/MM/YYYY',
  datePickerInput: 'DD/MM/YYYY',
  timePickerInput: 'HH:mm',
  dateTimeInput: 'DD/MM/YYYY HH:mm',
  monthYearLabel: 'MMMM YYYY',
  monthLabel: 'MMMM',
  weekdayLabel: 'ddd',
  // Define the time format
  hour12: 'h a',
  hour24: 'HH',
  minute: 'mm',
  second: 'ss'
};
